import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class NewsService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation NEWS_UPDATE(
          $id: String!
          $data: NewsInput!
        ) {
          newsUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.newsUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation NEWS_DESTROY($ids: [String!]!) {
          newsDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.newsDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation NEWS_CREATE($data: NewsInput!) {
          newsCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.newsCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation NEWS_IMPORT(
          $data: NewsInput!
          $importHash: String!
        ) {
          newsImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.newsImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query NEWS_FIND($id: String!) {
          newsFind(id: $id) {
            id
            title
            subtitle
            contentHtml
            description
            sourceUrl
            media {
              id
              name
              sizeInBytes
              publicUrl
              privateUrl
            }
            status
            propertyOwner {
              id
              fullName
              email
            }
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.newsFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query NEWS_LIST(
          $filter: NewsFilterInput
          $orderBy: NewsOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          newsList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              title
              subtitle
              contentHtml
              description
              media {
                id
                name
                sizeInBytes
                publicUrl
                privateUrl
              }
              status
              propertyOwner {
                id
                fullName
                email
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.newsList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query NEWS_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          newsAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.newsAutocomplete;
  }
}
